import React from "react";
import { FaBus, FaTaxi, FaPlane } from "react-icons/fa";

const transportModes = [
  { key: "bus", label: "Bus", Icon: FaBus },
  { key: "taxi", label: "Taxi", Icon: FaTaxi },
  { key: "air", label: "Air Travel", Icon: FaPlane },
];

const TransportOptions = ({ transport, onChange }) => {
  const handleToggleRequired = (e) => {
    const required = e.target.checked;
    onChange("transport", {
      required,
      modes: required
        ? transport.modes
        : { bus: false, taxi: false, air: false },
    });
  };

  const handleModeChange = (modeKey) => {
    onChange("transport", {
      ...transport,
      modes: {
        ...transport.modes,
        [modeKey]: !transport.modes[modeKey],
      },
    });
  };

  return (
    <div className="space-y-4">
      <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
        <input
          type="checkbox"
          checked={transport.required}
          onChange={handleToggleRequired}
        />
        Transport required
      </label>

      {transport.required && (
        <div className="pl-4 space-y-2">
          <p className="text-sm text-gray-600">Select applicable transport modes:</p>
          <div className="flex flex-wrap gap-6 text-sm text-gray-700">
            {transportModes.map(({ key, label, Icon }) => (
              <label key={key} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={transport.modes[key]}
                  onChange={() => handleModeChange(key)}
                />
                <span className="flex items-center gap-1">
                  <Icon className="text-blue-500" />
                  {label}
                </span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TransportOptions;
